import { AxiosResponse } from 'axios';
import { api } from './base/api';
import { ISupplierInventoryImportStatusApi } from './base/supplierInventoryImportStatusApi';
import { KeyValue } from '../models/common';
import { Result } from '../models/common/resultResponse';

const baseRoute: string = 'SupplierInventoryImportStatus';

export class SupplierInventoryImportStatusApi extends ISupplierInventoryImportStatusApi {
  getDomain(): Promise<AxiosResponse<Result<KeyValue[]>>> {
    return api.get(`${baseRoute}/domain`);
  }
}
